import Vue from "vue";
import VueRouter from "vue-router";
import Calculator from "@/views/Calculator.vue";
import Login from "../views/Login.vue";
import TermsConditions from "../views/TermsConditions.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
// import NProgress from "nprogress";
// import "nprogress/nprogress.css";

import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    alias: '/calculator',
    name: "Calculator",
    component: Calculator,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/terms-conditions",
    name: "Terms-Conditions",
    component: TermsConditions
  },
  {
    path: "/privacy",
    name: "Privacy-Policy",
    component: PrivacyPolicy
  },

  {
    path: "/calculos/",
    name: "Solutions",
    props: true,
    meta: {
      title: 'Soluções gravadas',
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Solutions.vue"),

    children: [
      {
        path: ":id",
        name: "Solution",
        props: true,
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Solution.vue")
      }
    ]
  },

  {
    path: "/logout",
    name: "Logout",
    props: true,
    beforeEnter(to, from, next) {
      store.dispatch("logout").then(() => {
        next({ name: "Calculator" });
      });
    }
  },

  {
    path: "/404",
    alias: "*",
    redirect: {
      name: "Calculator"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  linkExactActiveClass: "is-active--exact",
  linkActiveClass: "is-active",
  scrollBehavior() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }
});

router.beforeEach((to, from, next) => {
  store.state.authProcess.then(() => {
    if (
      to.matched.some(record => record.meta.requiresAuth) &&
      !store.state.user
    ) {
      next({
        name: "Login",
        query: {
          redirectTo: to.path
        }
      });
    } else {
      next();
    }
  });
});


export default router;
